// extracted by mini-css-extract-plugin
export default {"button":"vo","primary":"wo","fullWidth":"xo","secondary":"yo","nutrition":"zo","underlined":"Ao","small":"Bo","medium":"Co","info":"Eo","white":"Fo","border":"Go","mango":"Ho","charcoal":"Io","court":"Jo","green":"Ko","spark":"Lo","linkButton":"Mo","disabled":"No"};
    if(module.hot) {
      // 1711394575839
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  